import * as React from "react";
import { EventListRequest, EventType } from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import { AnalyticsService } from "../../services/AnalyticsService";
import { ColumnType } from "../list/list/ColumnType";
import { EntityDataTable } from "../list/list/EntityDataTable";
import { ListUtils } from "../list/list/ListUtils";
import { PagerModel } from "../list/list/PagerModel";
import { useState } from "react";
import {Form, FormListener} from "../form/Form";

interface Props {
    userId : number;
}

const PlayerAudit: React.FC<Props> = (props: Props) => {
    const analyticsService = getContainer().getAnalyticsService();
    const [date, setDate] = useState(new Date());
    const [startOfLastMonth, setStartOfLastMonth] = useState(new Date(new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0, 10)));
    const [lookupExpanded, setLookupExpanded] = useState(false);
    const [listRequest, setListRequest] = React.useState<EventListRequest>({ userId : props.userId, limit : 10, offset: 0, orderBy : "timestamp", ascending: false,
    types : [ EventType.LOGIN, EventType.CREATED, EventType.LOGIN, EventType.PASSWORDRESET, EventType.PASSWORDUPDATE, EventType.MFAENABLED ], startDate: startOfLastMonth, endDate: date } );
    const columns = [
        { property : "timestamp", name : "Timestamp", type : ColumnType.DATE},
        { property : "type", name : "Type" },
        { property : "remoteAddress", name : "IP Address" },
    ];

    const pagerChanged = (pager : PagerModel) => {
        if(!listRequest) {
            return;
        }
        var listRequestNew:EventListRequest= ListUtils.toListRequest<EventListRequest>(listRequest, pager);
        setListRequest(listRequestNew);
    }

           return (
                <div className={"card-box expandable-box"}  style={!lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !lookupExpanded ? setLookupExpanded(true) : null}>
            {lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); setLookupExpanded(false);}}><i className="mdi mdi-minus"></i></a>
                )}
                {!lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault();setLookupExpanded(true);}}><i className="mdi mdi-plus"></i></a>
                )}
                    <div className="" onClick={()=>setLookupExpanded (!lookupExpanded)}>
                        <h4>Player Audit</h4>
                    </div>
                    {lookupExpanded && (   <EntityDataTable
                        columns={columns}
                        service={analyticsService}
                        listRequest={listRequest}
                        onPagerChange={pagerChanged.bind(this)}
                        onAction={()=>undefined}
                    />
                    )}
            </div>
        )
    }

    export default PlayerAudit;
